const WAITING_TRANSCRIPTION = {
  key: 'AGUARDANDO_TRANSCRICAO_CONFERENCIA',
  color: '#9AD1D4',
  icon: 'fa-hourglass-half',
  description: 'Aguardando Transcrição',
  showInFilter: true,
};

const TRANSCRIPTION_IN_PROGRESS = {
  key: 'TRANSCRICAO_EM_PROGRESSO',
  color: '#A0A0A0',
  icon: 'fa-file-signature',
  description: 'Transcrição em progresso',
  showInFilter: false,
};

const WAITING_TRANSCRIPTION_APPROVE = {
  key: 'AGUARDANDO_APROVACAO_FARMACEUTICA',
  color: '#c9d68c',
  icon: 'fa-check-double',
  description: 'Aguardando Aprovação da Farmacêutica',
  showInFilter: true,
};

const WAITING_TRANSCRIPTION_COMPARE = {
  key: 'AGUARDANDO_CONFERENCIA_FARMACEUTICA',
  color: '#84BCDA',
  icon: 'fa-search',
  description: 'Aguardando Ação da Farmacêutica',
  showInFilter: true,
};

const SCHEDULED_PRODUCTION = {
  key: 'PRODUCAO_AGENDADA',
  color: 'green',
  icon: 'fa-clock',
  description: 'Produção Agendada',
  showInFilter: true,
};

const TRANSCRIPTION_APPROVED = {
  key: 'APROVADA',
  color: 'green',
  icon: 'fa-clipboard-check',
  description: 'Aprovada',
  showInFilter: true,
};

const TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION = {
  key: 'FALHA_ENVIO_SIPRO',
  color: '#F46036',
  icon: 'fa-exclamation-triangle',
  description: 'Erro ao enviar para produção',
  showInFilter: true,
};

const TRANSCRIPTION_DENIED = {
  key: 'CANCELADA',
  color: '#FE4A49',
  icon: 'fa-ban',
  description: 'Recusada',
  showInFilter: true,
};

const CANCELED_IN_PRODUCTION = {
  key: 'CANCELADA_NA_PRODUCAO',
  color: 'red',
  icon: 'fa-rectangle-xmark',
  description: 'Cancelada na Produção',
  showInFilter: true,
};

export {
  WAITING_TRANSCRIPTION,
  TRANSCRIPTION_IN_PROGRESS,
  WAITING_TRANSCRIPTION_APPROVE,
  WAITING_TRANSCRIPTION_COMPARE,
  SCHEDULED_PRODUCTION,
  TRANSCRIPTION_APPROVED,
  TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION,
  TRANSCRIPTION_DENIED,
  CANCELED_IN_PRODUCTION
};
